import apiClient from '../apiClient'

const dpAPI = {
  // 매장 목록 조회
  getShops: () => apiClient.get('/dp/shops'),

  // 스타일 조회
  getStyles: params => apiClient.get('/dp/styles', { params }),

  // 콤보박스 데이터 조회
  getComboData: () => apiClient.get('/dp/combo-data'),

  // DP 목록 조회
  getDpList: params => apiClient.get('/dp/dp-list', { params }),

  // DP 상세 조회
  getDpDetail: (dpCode, params) =>
    apiClient.get(`/dp/detail/${dpCode}`, { params }),

  // 수량 저장
  saveQuantities: (dpCode, data) =>
    apiClient.post(`/dp/quantities/${dpCode}`, data),

  // 평가 저장
  saveVote: (dpCode, data) => apiClient.post(`/dp/vote/${dpCode}`, data),

  // 아이템 타입별 요약 조회
  getItemSummary: params => apiClient.get('/dp/item-summary', { params }),
}

export default dpAPI
